export default function Terms() {
  return (
    <div className="min-h-screen bg-white py-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <h1 className="font-heading text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-8">
            Last updated: December 2024
          </p>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600">
              By accessing or using the American Real Estate Alliance ("AREA") website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">2. Membership Eligibility</h2>
            <p className="text-slate-600 mb-4">
              AREA membership is open to licensed real estate professionals and industry partners. By applying for membership, you represent that:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>You are at least 18 years of age</li>
              <li>You hold valid real estate credentials (for agent/broker memberships)</li>
              <li>All information provided is accurate and current</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">3. Member Conduct</h2>
            <p className="text-slate-600 mb-4">As an AREA member, you agree to:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Abide by the AREA Code of Ethics</li>
              <li>Treat fellow members with respect and professionalism</li>
              <li>Not use the platform for spam, harassment, or illegal activities</li>
              <li>Maintain the confidentiality of member information</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">4. Membership Fees</h2>
            <p className="text-slate-600">
              Membership fees are billed annually and are non-refundable. AREA reserves the right to modify membership fees with 30 days notice to members.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">5. Intellectual Property</h2>
            <p className="text-slate-600">
              All content on the AREA website, including text, graphics, logos, and software, is the property of AREA or its licensors and is protected by copyright and trademark laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">6. Limitation of Liability</h2>
            <p className="text-slate-600">
              AREA is not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for membership in the preceding 12 months.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">7. Termination</h2>
            <p className="text-slate-600">
              AREA may terminate or suspend your membership at any time for violation of these terms or the Code of Ethics. You may cancel your membership at any time through your account settings.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">8. Changes to Terms</h2>
            <p className="text-slate-600">
              We reserve the right to modify these terms at any time. We will notify members of material changes via email or through the member portal.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">9. Contact</h2>
            <p className="text-slate-600">
              For questions about these Terms of Service, contact us at legal@area.org.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
